import { ArrowPathIcon, ArrowRightOnRectangleIcon, XCircleIcon } from "@heroicons/react/24/outline";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { FC, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import * as Yup from "yup";
import logoImg from "../../../assets/images/logo.jpeg";
import {
  ButtonPrimary,
  ButtonSecondary
} from "../../../components";

// import { signIn, signOut } from "../services/AuthSlice";
// import { GET_AUTHSYSTEM } from "../services/AuthSystemSlice";

import { createDataPuNIB, getsDataInquiryNIB, getsDataProfileNIB } from "modules/Pu/services/DataNIB";
import { getsDataPuNIBKbli } from "modules/Pu/services/DataNIBKbli";
import { DataPu, DataPuProyek } from "modules/Pu/services/types";
import { createRegSelfdeclare, getsRegSelfdeclare } from "modules/Registration/services/RegistrationSelfdeclare";
import { credentialsSSO, signUpSaliha, userInfoSaliha } from "../services/SalihaAuth";
import { updateRegistrationSaliha } from "../services/SalihaSubmission";
import SalihaCardSubmission from "./SalihaCardSubmission";
import { createRegReguler, getsRegReguler } from "modules/Registration/services/RegistrationReguler";

export interface PageSalihaSubmissionProps {
  className?: string;
}

type SalihaSubmissionForm = {
  username: string;
  password: string;
};

const SalihaSubmission: FC<PageSalihaSubmissionProps> = ({ className = "" }) => {
  let navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [searchParams, setSearchParams] = useSearchParams();
  const [errorPU, setErrorPu] = useState(false);
  const _credentials = searchParams.get("credentials")

  // const _refresh_token = searchParams.get("refresh_token")
  // const _kd_id = searchParams.get("kd_id")
  // const _id_izin = searchParams.get("id_izin")

  const {
    // isSuccessSignUp: isSuccessSignUpSalihaAuth,
    dataUserInfo: dataUserInfoSaliha,
    isSuccessUserInfo,
    isSuccessCredentials,
    isSuccessSignUp,
    dataSignUp: dataSignUpSalihaAuth,
    dataCredentials,
    isError: isErrorSalihaAuth,
    isFetching: isFetchingSalihaAuth,
    errorMessage: errorMessageSalihaAuth
  } = useAppSelector((state) => state.salihaAuthSlice);

  const {
    dataInquiry: dataInquiryNIB,
    isSuccessInquiry: isSuccessInquiryNIB,
    isErrorProfile: isErrorProfileNIB,

    dataProfile: dataProfileNIB,
    isSuccessProfile: isSuccessProfileNIB,
    isErrorInquiry: isErrorInquiryNIB,

    isSuccessCreateDataPuNIB,
    dataCreatePuNIB,
    isFetchingCreateDataPuNib,

    isFetching: isFetchingInquiryNIB,
    errorMessage: errorMessageInquiryNIB
  } = useAppSelector((state) => state.inquiryNIB);


  const {
    dataKbli,
    isSuccessKbli,
    isError: isErrorDataNIBKbli,
    isFetching: isFetchingDataNIBKbli,
    errorMessage: errorMessageDataNIBKbli
  } = useAppSelector((state) => state.puKbli);

  const {
    data: dataSalihaSubmission,
    isUpdateSuccess: isUpdateSuccessSalihaSubmission,
    isError: isErrorSalihaSubmission,
    isUpdateFetching: isUpdateFetchingSalihaSubmission,
    errorMessage: errorMessageSalihaSubmission
  } = useAppSelector((state) => state.salihaSubmission);

  const {
    dataRegSelfdeclare,
    listRegSelfdeclare,

    isSuccessCreateRegSelfdeclare,
    isSuccessGetsRegSelfdeclare,

    isErrorCreateRegSelfdeclare,

    isFetching: isFetchingReg,
    errorMessage: errorMessageReg
  } = useAppSelector((state) => state.registrationSelfdeclare);

  const {
    dataRegReguler,
    listRegReguler,

    isSuccessCreateRegReguler,
    isSuccessGetsRegReguler,

    isErrorCreateRegReguler,

    isFetching: isFetchingRegReguler,
    errorMessage: errorMessageRegSelfdeclare
  } = useAppSelector((state) => state.registrationReguler);

  // const [client, setClientId] = useState<boolean | null>(false)
  // const [profile, setProfile] = useState<any | null>(false)
  // const [credential, setCredential] = useState<any | null>(false)

  const validationSchema = Yup.object().shape({
    username: Yup.string().required("Email is required"),
    password: Yup.string()
      .required("Password is required")
      .min(6, "Password must be at least 6 characters")
      .max(40, "Password must not exceed 40 characters"),
  });

  const {
    register,
    handleSubmit,
    // reset,
    formState: { errors },
  } = useForm<SalihaSubmissionForm>({
    resolver: yupResolver(validationSchema),
  });


  useEffect(() => {

    // jika tidak terdaftar

    // check apakah user & nib sudah diguakan

    // jika user sudah diguakan cek apakah nib nya sama jika sama maka user tersebut masuk dengan akun yang benar
    // jik

    async function _checkCredentials() {
      if (_credentials) {
        dispatch(credentialsSSO({
          CREDENTIALS_SSO: {
            Credentials: _credentials
          }
        }))
      }
    }

    _checkCredentials()

  }, [dispatch]);


  useEffect(() => {

    // jika tidak terdaftar

    // check apakah user & nib sudah diguakan

    // jika user sudah diguakan cek apakah nib nya sama jika sama maka user tersebut masuk dengan akun yang benar
    // jik

    async function _checkUserInfoSaliha() {
      if (dataCredentials.CREDENTIALS_SSO.data.Token) {
        dispatch(userInfoSaliha({
          access_token: dataCredentials.CREDENTIALS_SSO.data.Token
        }))
      }
    }

    async function _checkInquiryNIBSaliha() {
      if (dataCredentials.CREDENTIALS_SSO.data.Token) {
        dispatch(getsDataInquiryNIB({
          filter: { nib: dataCredentials.CREDENTIALS_SSO.data.Nib }
        }))
      }
    }

    if (isSuccessCredentials) {
      _checkUserInfoSaliha()
      _checkInquiryNIBSaliha()
    }

  }, [dispatch, isSuccessCredentials]);

  useEffect(() => {
    async function _checkProfileNIBSaliha() {
      if (dataCredentials.CREDENTIALS_SSO.data.Token) {
        dispatch(getsDataProfileNIB({
          pagination: {
            page: 1,
            perPage: 1
          },
          filter: {
            nib: dataCredentials.CREDENTIALS_SSO.data.Nib
          }
        }))
      }
    }

    async function _checkSignUpSaliha() {
      if (dataCredentials.CREDENTIALS_SSO.data.Nib && dataUserInfoSaliha.data.email) {
        dispatch(signUpSaliha({
          REGISTER: {
            emailAddr: dataUserInfoSaliha.data.email,
            nama: dataInquiryNIB.GETS_INQUIRYNIB.data.namaPerseroan,
            role: "R.10",
            password: dataCredentials.CREDENTIALS_SSO.data.Nib,
          }
        }))
      }
    }

    async function _checkNIBKbliSaliha() {
      if (dataCredentials.CREDENTIALS_SSO.data.Token) {
        dispatch(getsDataPuNIBKbli({
          pagination: {
            page: 1,
            perPage: 20
          },
          filter: {
            IdPu: dataProfileNIB.GETS_PU.data[0].IdPu
          }
        }))
      }
    }

    if (isSuccessInquiryNIB) {
      _checkProfileNIBSaliha()
      // dispatch(clearStateDataNIBInquiry({}))
    }

    if (isSuccessProfileNIB && isSuccessUserInfo) {
      _checkSignUpSaliha()
      _checkNIBKbliSaliha()
      // check apakah email yang ada di userinfo dan di user sama atau tidak
    }

    if (isErrorProfileNIB && isSuccessUserInfo) {
      _checkSignUpSaliha()
    }

  }, [dispatch, isSuccessInquiryNIB, isSuccessProfileNIB, isErrorProfileNIB, isSuccessUserInfo]);

  useEffect(() => {

    async function _createDataPuNib() {
      if (dataCredentials.CREDENTIALS_SSO.data.Nib) {
        dispatch(createDataPuNIB({
          CREATE_PU: {
            Nib: dataCredentials.CREDENTIALS_SSO.data.Nib,
            UnikId: dataSignUpSalihaAuth.REGISTER.data.unik_id
          }
        }))
      }
    }

    if (isSuccessSignUp) {
      if (dataProfileNIB.GETS_PU.data.length > 0 && dataSignUpSalihaAuth.REGISTER) {
        if (dataProfileNIB.GETS_PU.data[0].IdPu?.toString().toUpperCase() !== dataSignUpSalihaAuth.REGISTER.data.unik_id.toString().toUpperCase()) {
          setErrorPu(true)
        } else {
          _createDataPuNib()
        }
      }

    }

  }, [dispatch, isSuccessSignUp]);

  useEffect(() => {

    async function _checkNIBKbliSaliha() {
      if (dataCredentials.CREDENTIALS_SSO.data.Token) {
        dispatch(getsDataPuNIBKbli({
          pagination: {
            page: 1,
            perPage: 20
          },
          filter: {
            IdPu: dataCreatePuNIB.CREATE_PU.data.IdPu
          }
        }))
      }
    }

    async function _getsRegistrasiSeldeclare() {
      if (dataCredentials.CREDENTIALS_SSO.data.Token) {
        dispatch(getsRegSelfdeclare({
          pagination: {
            page: 1,
            perPage: 20
          },
          filter: {
            IdPu: dataCreatePuNIB.CREATE_PU.data.IdPu,
            JenisProduk: dataCredentials.CREDENTIALS_SSO.data.JenisProduk,
          }
        }))
      }
    }

    async function _getsRegistrasiReguler() {
      if (dataCredentials.CREDENTIALS_SSO.data.Token) {
        dispatch(getsRegReguler({
          pagination: {
            page: 1,
            perPage: 20
          },
          filter: {
            IdPu: dataCreatePuNIB.CREATE_PU.data.IdPu,
            JenisProduk: dataCredentials.CREDENTIALS_SSO.data.JenisProduk,
          }
        }))
      }
    }

    if (isSuccessCreateDataPuNIB) {
      _checkNIBKbliSaliha()

      if (dataCredentials.CREDENTIALS_SSO.data.JenisPendaftaran === "CH003") {
        _getsRegistrasiSeldeclare()
      }

      if (dataCredentials.CREDENTIALS_SSO.data.JenisPendaftaran === "CH001") {
        _getsRegistrasiReguler()
      }
    }

  }, [dispatch, isSuccessCreateDataPuNIB]);


  // setelah cek kbli, cek pengajuan sudah ada atau belum

  useEffect(() => {

    async function _updateSalihaAppReguler() {
      if (dataCredentials.CREDENTIALS_SSO.data.Nib && dataCredentials.CREDENTIALS_SSO.data.JenisProduk && dataCredentials.CREDENTIALS_SSO.data.Kbli) {
        dispatch(updateRegistrationSaliha({
          Id: dataRegReguler.CREATE_REGISTRATION.data.IdReg,
          ChannelId: dataCredentials.CREDENTIALS_SSO.data.JenisPendaftaran,
          SumberData: "SALIHA",
          Nib: dataCredentials.CREDENTIALS_SSO.data.Nib,
          JenisProduk: dataCredentials.CREDENTIALS_SSO.data.JenisProduk,
          Kbli: dataCredentials.CREDENTIALS_SSO.data.Kbli,
          Status: "OF1",
          NoDaftar: dataRegReguler.CREATE_REGISTRATION.data.IdReg.toString()
        }))
      }
    }

    async function _updateSalihaAppSelfdeclare() {
      if (dataCredentials.CREDENTIALS_SSO.data.Nib && dataCredentials.CREDENTIALS_SSO.data.JenisProduk && dataCredentials.CREDENTIALS_SSO.data.Kbli) {
        dispatch(updateRegistrationSaliha({
          Id: dataRegSelfdeclare.CREATE_REGISTRATION.data.IdReg,
          ChannelId: dataCredentials.CREDENTIALS_SSO.data.JenisPendaftaran,
          SumberData: "SALIHA",
          Nib: dataCredentials.CREDENTIALS_SSO.data.Nib,
          JenisProduk: dataCredentials.CREDENTIALS_SSO.data.JenisProduk,
          Kbli: dataCredentials.CREDENTIALS_SSO.data.Kbli,
          Status: "OF1",
          NoDaftar: dataRegSelfdeclare.CREATE_REGISTRATION.data.IdReg.toString()
        }))
      }
    }

    if (isSuccessCreateRegSelfdeclare) {
      _updateSalihaAppSelfdeclare()
    }

    if (isSuccessCreateRegReguler) {
      _updateSalihaAppReguler()
    }

  }, [dispatch, isSuccessCreateRegSelfdeclare, isSuccessCreateRegReguler]);


  // useEffect(() => {

  //   async function _getsRegistrationSaliha() {
  //     // if (dataUserInfoOss.data.email !== "" && dataUserInfoOss.data.nama !== "") {
  //     dispatch(getsRegistrationSaliha({
  //       pagination: {
  //         perPage: 1,
  //         size: 10,
  //       },
  //       filter: {
  //         Id: 0,
  //         Nib: "",
  //         Kbli: "",
  //       },
  //       sort: {
  //         Id: 0,
  //         Nib: "",
  //         Kbli: "",
  //       }
  //     }))
  //     // }
  //   }

  //   _getsRegistrationSaliha()

  // }, [dispatch]);

  // useEffect(() => {
  //   if (isSuccessCreateRegSelfdeclare) {
  //     window.location.replace('/');
  //   }

  // }, [isSuccessCreateRegSelfdeclare]);

  const doSalihaSubmission = () => {
    let _area_pemasaran = 'MKT02';
    if (dataCredentials.CREDENTIALS_SSO.data.AreaPemasaran === "Kabupaten/Kota") {
      _area_pemasaran = 'MKT00'
    }

    if (dataCredentials.CREDENTIALS_SSO.data.AreaPemasaran === "Provinsi") {
      _area_pemasaran = 'MKT01'
    }

    if (dataCredentials.CREDENTIALS_SSO.data.AreaPemasaran === "Nasional") {
      _area_pemasaran = 'MKT02'
    }

    if (dataCredentials.CREDENTIALS_SSO.data.AreaPemasaran === "Internasional") {
      _area_pemasaran = 'MKT03'
    }

    if (dataCredentials.CREDENTIALS_SSO.data.JenisPendaftaran === 'CH003') {
      dispatch(createRegSelfdeclare({
        CREATE_REGISTRATION: {
          Kbli: dataCredentials.CREDENTIALS_SSO.data.Kbli,
          UnikId: dataSignUpSalihaAuth.REGISTER.data.unik_id,
          JenisProduk: dataCredentials.CREDENTIALS_SSO.data.JenisProduk,
          AreaPemasaran: _area_pemasaran,
          MerekDagang: dataCredentials.CREDENTIALS_SSO.data.MerekDagang,
          NamaPJ: dataCredentials.CREDENTIALS_SSO.data.NamaPJ,
          EmailPJ: dataCredentials.CREDENTIALS_SSO.data.EmailPJ,
          NomorTelpPJ: dataCredentials.CREDENTIALS_SSO.data.NomorTelpPJ,
        }
      }))
    }

    if (dataCredentials.CREDENTIALS_SSO.data.JenisPendaftaran === 'CH001') {
      dispatch(createRegReguler({
        CREATE_REGISTRATION: {
          Kbli: dataCredentials.CREDENTIALS_SSO.data.Kbli,
          UnikId: dataSignUpSalihaAuth.REGISTER.data.unik_id,
          JenisProduk: dataCredentials.CREDENTIALS_SSO.data.JenisProduk,
          AreaPemasaran: _area_pemasaran,
          MerekDagang: dataCredentials.CREDENTIALS_SSO.data.MerekDagang,
          NamaPJ: dataCredentials.CREDENTIALS_SSO.data.NamaPJ,
          EmailPJ: dataCredentials.CREDENTIALS_SSO.data.EmailPJ,
          NomorTelpPJ: dataCredentials.CREDENTIALS_SSO.data.NomorTelpPJ,
        }
      }))
    }
  };

  const doSelanjutnnyya = () => {
    if (isUpdateSuccessSalihaSubmission) {

      const channel_id = dataCredentials.CREDENTIALS_SSO.data.JenisPendaftaran

      if (dataCredentials.CREDENTIALS_SSO.data.JenisPendaftaran === "CH003") {
        window.location.replace(`${process.env.REACT_APP_ASP_URL}/auth?grant=SSO&username=${dataUserInfoSaliha.data.email}&id_reg=${dataRegSelfdeclare.CREATE_REGISTRATION
          // window.location.replace(`https://test.halal.go.id/auth?grant=SSO&username=${dataUserInfoSaliha.data.email}&id_reg=${dataRegSelfdeclare.CREATE_REGISTRATION
          .data.IdReg}&channel_id=${channel_id}`);
      } else {
        window.location.replace(`${process.env.REACT_APP_ASP_URL}/auth?grant=SSO&username=${dataUserInfoSaliha.data.email}&id_reg=${dataRegReguler.CREATE_REGISTRATION
          // window.location.replace(`https://test.halal.go.id/auth?grant=SSO&username=${dataUserInfoSaliha.data.email}&id_reg=${dataRegSelfdeclare.CREATE_REGISTRATION
          .data.IdReg}&channel_id=${channel_id}`);
      }
    }
  }

  const doEditSelanjutnnya = (idReg: number) => {

    const channel_id = dataCredentials.CREDENTIALS_SSO.data.JenisPendaftaran

    // console.log(`
    // http://localhost:55660/auth?grant=SSO&username=${dataUserInfoSaliha.data.email}&id_reg=${dataRegSelfdeclare.CREATE_REGISTRATION
    //     .data.IdReg
    //   }&channel_id=CH003
    // `)

    window.location.replace(`${process.env.REACT_APP_ASP_URL}/auth?grant=SSO&username=${dataUserInfoSaliha.data.email}&id_reg=${idReg}&channel_id=${channel_id}`);
  }

  const doLogout = () => {
    // dispatch(signOut({}));
  }

  const checkUserOss = () => {
    return (
      <ButtonSecondary
        // disabled={!client}
        loading={true}
        className="w-full"
        // sizeClass="px-2 py-1 sm:px-1"
        type="button"
      // onClick={() => doSelanjutnnyya()}
      >
        Mohon Tunggu
      </ButtonSecondary>
    )
  }

  const clientReject = (label: string) => {
    return (
      <>
        <div className={`nc-PageLogin bg-gray-100 ${className} `} data-nc-id="PageLogin">
          <div className="container h-screen flex w-full justify-center ">

            <div className="mx-auto max-w-2xl mt-10">
              <div className="rounded-xl bg-gray-50 min-full">
                <div className="rounded-xl bg-white p-5 pb-20 text-white">
                  <div className="w-full flex flex-row justify-start space-x-5 items-center">
                    <img
                      className={`block max-h-16`}
                      src={logoImg}
                      alt="Logo"
                    />
                    <div>
                      <h1 className="text-gray-600 text-sm md:text-xl leading-4 md:leading-5 w-full flex flex-col justify-start items-start">
                        <span>
                          BADAN PENYELENGARA
                        </span>
                        <span className="font-bold">
                          JAMINAN PRODUK HALAL
                        </span>
                        <span>
                          KEMENTRIAN AGAMA RI
                        </span>
                      </h1>
                    </div>
                  </div>
                </div>

                <div className="-mt-20 p-5">
                  <div className="rounded-xl bg-white p-4 font-medium text-gray-500 shadow-sm">
                    <div className="my-5"></div>
                    <div
                      className="p-1 text-xs rounded-full bg-red-300 items-center text-gray-800 leading-none lg:rounded-full flex lg:inline-flex"
                      role="alert">
                      <span className="flex mr-3">
                        <XCircleIcon className="w-5 text-red-500" />
                      </span>
                      <span className="font-semibold mr-2 text-left flex-auto">
                        {label}
                      </span>
                      <svg
                        className="fill-current opacity-75 h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20">
                        <path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div >

      </>
    )
  }

  const errorMessage = (text: any) => {
    return (
      <>
        <div className="mb-2"></div>
        <div
          className="p-1 text-xs rounded-full bg-red-300 items-center text-gray-800 leading-none lg:rounded-full flex lg:inline-flex"
          role="alert">
          <span className="flex mr-3">
            <XCircleIcon className="w-5 text-red-500" />
          </span>
          <span className="font-semibold mr-2 text-left flex-auto">
            {/* {errorMessage} */}
            {
              text === "Email has been registered" && "Mohon maaf email yang anda gunakan sudah terdaftar oleh orang lain"
            }
          </span>
        </div>
      </>
    )
  }

  // const renderPuTableSelfdeclare = () => {
  //   return (
  //     <>
  //       {
  //         isSuccessSalihaSubmission && (
  //           dataSalihaSubmission.GETS_PRAREGISTRATIONSALIHA.data.map((value, index) => {
  //             return (
  //               <div
  //                 key={`dataNIBChecklist-${index}`}>
  //                 <CardPengajuanPu praSubmission={value} />
  //               </div>
  //             )
  //           })
  //         )
  //       }
  //     </>
  //   )
  // }

  const renderPuTableSelfdeclare = () => {
    return (
      <>

        {
          isSuccessKbli && (
            dataKbli.GETS_PU.data.map((value: DataPu, index: number) => {
              let kbli = {} as DataPuProyek;
              if (index === 0) {
                value.PuProyek.map((proyek: DataPuProyek) => {
                  if (dataCredentials.CREDENTIALS_SSO.data.Kbli === proyek.Kbli) {
                    kbli = proyek
                  }
                })

                if (kbli != null) {

                  if (isSuccessGetsRegSelfdeclare) {
                    if (!listRegSelfdeclare.GETS_REGISTRATION.data) {
                      return (
                        <div
                          key={`dataNIBProyek-${index}`}>
                          <SalihaCardSubmission submission={kbli} />

                          <div className="flex flex-row space-x-3 w-full mt-5">
                            <ButtonSecondary
                              // disabled={!client}
                              // loading={isFetching}
                              className="w-full"
                              type="button"
                              onClick={() => doLogout()}
                            >
                              Keluar <XCircleIcon className="font-bold ml-5 w-6" />
                            </ButtonSecondary>
                            <ButtonPrimary
                              // disabled={!client}
                              loading={isFetchingReg}
                              className="w-full"
                              type="button"
                              onClick={() => doSalihaSubmission()}
                            >
                              Selanjutnya <ArrowRightOnRectangleIcon className="font-bold ml-5 w-6" /> <br />
                            </ButtonPrimary>
                          </div>
                        </div>
                      )
                    }

                    return (
                      listRegSelfdeclare.GETS_REGISTRATION?.data?.map((value, index) => {
                        if (kbli.UraianUsaha.toString().toUpperCase() === value.NamaPuAlt?.toString().toUpperCase()) {
                          return (
                            <div
                              key={`OldSubmission-${index}`}>
                              <SalihaCardSubmission oldsubmission={value} />

                              <div className="flex flex-row space-x-3 w-full mt-5">
                                <ButtonSecondary
                                  // disabled={!client}
                                  // loading={isFetching}
                                  className="w-full"
                                  type="button"
                                  onClick={() => doLogout()}
                                >
                                  Keluar <XCircleIcon className="font-bold ml-5 w-6" />
                                </ButtonSecondary>
                                <ButtonPrimary
                                  // disabled={!client}
                                  loading={isFetchingReg}
                                  className="w-full"
                                  type="button"
                                  onClick={() => doEditSelanjutnnya(value.IdReg)}
                                >
                                  Selanjutnya <ArrowRightOnRectangleIcon className="font-bold ml-5 w-6" /> <br />
                                </ButtonPrimary>
                              </div>
                            </div>
                          )
                        } else {
                          return (
                            <div
                              key={`dataNIBProyek-${index}`}>
                              <SalihaCardSubmission submission={kbli} />

                              <div className="flex flex-row space-x-3 w-full mt-5">
                                <ButtonSecondary
                                  // disabled={!client}
                                  // loading={isFetching}
                                  className="w-full"
                                  type="button"
                                  onClick={() => doLogout()}
                                >
                                  Keluar <XCircleIcon className="font-bold ml-5 w-6" />
                                </ButtonSecondary>
                                <ButtonPrimary
                                  // disabled={!client}
                                  loading={isFetchingReg}
                                  className="w-full"
                                  type="button"
                                  onClick={() => doSalihaSubmission()}
                                >
                                  Selanjutnya <ArrowRightOnRectangleIcon className="font-bold ml-5 w-6" /> <br />
                                </ButtonPrimary>
                              </div>
                            </div>
                          )
                        }
                      })
                    )
                  }
                } else {
                  return (
                    <>Kbli tidak ditemukan <br />
                      <div className="flex flex-row space-x-3 w-full mt-5">
                        <ButtonSecondary
                          // disabled={!client}
                          // loading={isFetching}
                          className="w-full"
                          type="button"
                          onClick={() => doLogout()}
                        >
                          Keluar <XCircleIcon className="font-bold ml-5 w-6" />
                        </ButtonSecondary>
                        <ButtonPrimary
                          disabled
                          // disabled={!client}
                          loading={isFetchingReg}
                          className="w-full"
                          type="button"
                        // onClick={() => doSalihaSubmission()}
                        >
                          Selanjutnya <ArrowRightOnRectangleIcon className="font-bold ml-5 w-6" /> <br />
                        </ButtonPrimary>
                      </div>
                    </>
                  )
                }
              }

            })
          )
        }
      </>
    )
  }

  const renderPuTableReguler = () => {
    return (
      <>

        {
          isSuccessKbli && (
            dataKbli.GETS_PU.data.map((value: DataPu, index: number) => {
              let kbli = {} as DataPuProyek;
              if (index === 0) {
                value.PuProyek.map((proyek: DataPuProyek) => {
                  if (dataCredentials.CREDENTIALS_SSO.data.Kbli === proyek.Kbli) {
                    kbli = proyek
                  }
                })

                if (kbli != null) {

                  if (isSuccessGetsRegReguler) {
                    if (!listRegReguler.GETS_REGISTRATION.data) {
                      return (
                        <div
                          key={`dataNIBProyek-${index}`}>
                          <SalihaCardSubmission submission={kbli} />

                          <div className="flex flex-row space-x-3 w-full mt-5">
                            <ButtonSecondary
                              // disabled={!client}
                              // loading={isFetching}
                              className="w-full"
                              type="button"
                              onClick={() => doLogout()}
                            >
                              Keluar <XCircleIcon className="font-bold ml-5 w-6" />
                            </ButtonSecondary>
                            <ButtonPrimary
                              // disabled={!client}
                              loading={isFetchingReg}
                              className="w-full"
                              type="button"
                              onClick={() => doSalihaSubmission()}
                            >
                              Selanjutnya <ArrowRightOnRectangleIcon className="font-bold ml-5 w-6" /> <br />
                            </ButtonPrimary>
                          </div>
                        </div>
                      )
                    }

                    return (
                      listRegReguler.GETS_REGISTRATION?.data?.map((value, index) => {
                        if (kbli.UraianUsaha.toString().toUpperCase() === value.NamaPuAlt?.toString().toUpperCase()) {
                          return (
                            <div
                              key={`OldSubmission-${index}`}>
                              <SalihaCardSubmission oldsubmission={value} />

                              <div className="flex flex-row space-x-3 w-full mt-5">
                                <ButtonSecondary
                                  // disabled={!client}
                                  // loading={isFetching}
                                  className="w-full"
                                  type="button"
                                  onClick={() => doLogout()}
                                >
                                  Keluar <XCircleIcon className="font-bold ml-5 w-6" />
                                </ButtonSecondary>
                                <ButtonPrimary
                                  // disabled={!client}
                                  loading={isFetchingReg}
                                  className="w-full"
                                  type="button"
                                  onClick={() => doEditSelanjutnnya(value.IdReg)}
                                >
                                  Selanjutnya <ArrowRightOnRectangleIcon className="font-bold ml-5 w-6" /> <br />
                                </ButtonPrimary>
                              </div>
                            </div>
                          )
                        } else {
                          return (
                            <div
                              key={`dataNIBProyek-${index}`}>
                              <SalihaCardSubmission submission={kbli} />

                              <div className="flex flex-row space-x-3 w-full mt-5">
                                <ButtonSecondary
                                  // disabled={!client}
                                  // loading={isFetching}
                                  className="w-full"
                                  type="button"
                                  onClick={() => doLogout()}
                                >
                                  Keluar <XCircleIcon className="font-bold ml-5 w-6" />
                                </ButtonSecondary>
                                <ButtonPrimary
                                  // disabled={!client}
                                  loading={isFetchingReg}
                                  className="w-full"
                                  type="button"
                                  onClick={() => doSalihaSubmission()}
                                >
                                  Selanjutnya <ArrowRightOnRectangleIcon className="font-bold ml-5 w-6" /> <br />
                                </ButtonPrimary>
                              </div>
                            </div>
                          )
                        }
                      })
                    )
                  }
                } else {
                  return (
                    <>Kbli tidak ditemukan <br />
                      <div className="flex flex-row space-x-3 w-full mt-5">
                        <ButtonSecondary
                          // disabled={!client}
                          // loading={isFetching}
                          className="w-full"
                          type="button"
                          onClick={() => doLogout()}
                        >
                          Keluar <XCircleIcon className="font-bold ml-5 w-6" />
                        </ButtonSecondary>
                        <ButtonPrimary
                          disabled
                          // disabled={!client}
                          loading={isFetchingReg}
                          className="w-full"
                          type="button"
                        // onClick={() => doSalihaSubmission()}
                        >
                          Selanjutnya <ArrowRightOnRectangleIcon className="font-bold ml-5 w-6" /> <br />
                        </ButtonPrimary>
                      </div>
                    </>
                  )
                }
              }

            })
          )
        }
      </>
    )
  }

  if (isSuccessCreateRegSelfdeclare || isSuccessCreateRegReguler) {
    return (
      <div className={`nc-PageLogin bg-gray-100 ${className} `} data-nc-id="PageLogin">
        <div className="container h-screen flex w-full justify-center ">

          <div className="mx-auto max-w-2xl mt-10">
            <div className="rounded-xl bg-gray-50 min-full">
              <div className="rounded-xl bg-white p-5 pb-20 text-white">
                <div className="w-full flex flex-row justify-start space-x-5 items-center">
                  <img
                    className={`block max-h-16`}
                    src={logoImg}
                    alt="Logo"
                  />
                  <div>
                    <h1 className="text-gray-600 text-sm md:text-xl leading-4 md:leading-5 w-full flex flex-col justify-start items-start">
                      <span>
                        BADAN PENYELENGARA
                      </span>
                      <span className="font-bold">
                        JAMINAN PRODUK HALAL
                      </span>
                      <span>
                        KEMENTRIAN AGAMA RI
                      </span>
                    </h1>
                  </div>
                </div>

              </div>

              <div className="-mt-20 p-5">
                <div className="rounded-xl bg-white p-4 font-medium text-gray-500 shadow-sm">
                  {
                    isFetchingInquiryNIB ? checkUserOss() :
                      <>
                        <div className="mb-3 text-sm">Hi {dataInquiryNIB.GETS_INQUIRYNIB.data.namaPerseroan}</div>

                        <ButtonPrimary
                          // disabled={!client}
                          // loading={isFetching}
                          className="w-full"
                          // sizeClass="px-2 py-1 sm:px-1"
                          type="button"
                        // onClick={() => doSelanjutnnyya()}
                        >
                          <span className="mr-5">Refresh</span>
                          <ArrowPathIcon className="aspect-square w-5 rounded-lg bg-center object-cover" />
                        </ButtonPrimary>
                      </>
                  }
                  {
                    isErrorSalihaAuth && errorMessage(errorMessageSalihaAuth)
                  }
                </div>
              </div>

              <section className="p-5">
                <div className="mb-5 flex items-center justify-between">
                  <h4 className="font-medium text-slate-500">Pengajuan</h4>
                  <div className="rounded-md bg-purple-100 px-2 font-semibold text-gray-900"></div>
                </div>
                <div className="space-y-2">
                  <div className="w-full max-w-sm overflow-hidden rounded-lg duration-300">
                    <svg xmlns="http://www.w3.org/2000/svg" className="mx-auto mt-8 h-16 w-16 text-green-400" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                    </svg>
                    <h1 className="mt-2 text-center text-2xl font-bold text-gray-500">Success</h1>
                  </div>
                  {/* {renderPuTableSelfdeclare()} */}
                </div>
              </section>

              <section className="p-5">
                <div className="flex flex-row space-x-3 w-full">
                  {/* <ButtonSecondary
                    // disabled={!client}
                    // loading={isFetching}
                    className="w-full"
                    type="button"
                    onClick={() => doLogout()}
                  >
                    Keluar <XCircleIcon className="font-bold ml-5 w-6" />
                  </ButtonSecondary> */}
                  <ButtonPrimary
                    // disabled={!client}
                    // loading={isFetching}
                    className="w-full"
                    type="button"
                    onClick={() => doSelanjutnnyya()}
                  >
                    Masuk ke halaman sihalal <ArrowRightOnRectangleIcon className="font-bold ml-5 w-6" /> <br />
                  </ButtonPrimary>
                </div>
              </section>

            </div>
          </div>

        </div>

      </div>
    )
  }

  // if (isFetchingSalihaAuth) {

  // }

  if (!dataUserInfoSaliha.status && !isFetchingSalihaAuth) {
    return (
      <>
        {clientReject("akses ditolak")}
      </>
    )
  }

  if (isErrorInquiryNIB) {
    return (
      <>
        {clientReject(`akses ditolak, NIB ${dataCredentials.CREDENTIALS_SSO.data.Nib} tidak ditemukan`)}
      </>
    )
  }

  if (errorPU) {
    return (
      <>
        {clientReject(`akses ditolak, data pengguna tidak sesuai`)}
      </>
    )
  }

  // if (dataProfileNIB.GETS_PU.data.length > 0 && dataSignUpSalihaAuth.REGISTER) {
  //   if (dataProfileNIB.GETS_PU.data[0].IdPu?.toString().toUpperCase() !== dataSignUpSalihaAuth.REGISTER.data.unik_id.toString().toUpperCase()) {
  //     return (
  //       <>
  //         {clientReject(`akses ditolak, data pengguna tidak sesuai`)}
  //       </>
  //     )
  //   }
  // }


  return (
    <div className={`nc-PageLogin bg-gray-100 ${className} `} data-nc-id="PageLogin">
      <div className="container h-screen flex w-full justify-center ">

        <div className="mx-auto max-w-2xl mt-10">
          <div className="rounded-xl bg-gray-50 min-full">
            <div className="rounded-xl bg-white p-5 pb-20 text-white">
              <div className="w-full flex flex-row justify-start space-x-5 items-center">
                <img
                  className={`block max-h-16`}
                  src={logoImg}
                  alt="Logo"
                />
               
              </div>

            </div>

            <div className="-mt-20 p-5">
              <div className="rounded-xl bg-white p-4  text-gray-600 shadow-sm">
                {
                  isFetchingInquiryNIB ? checkUserOss() :
                    <>
                      <div className="mb-3 text-sm flex flex-col justify-start">
                        <span>SELAMAT DATANG</span>
                        <span className="font-bold">{dataInquiryNIB.GETS_INQUIRYNIB.data.namaPerseroan}</span>
                      </div>

                      <ButtonPrimary
                        // disabled={!client}
                        // loading={isFetching}
                        className="w-full"
                        // sizeClass="px-2 py-1 sm:px-1"
                        type="button"
                      // onClick={() => doSelanjutnnyya()}
                      >
                        <span className="mr-5">Muat Ulang</span>
                        <ArrowPathIcon className="aspect-square w-5 rounded-lg bg-center object-cover" />
                      </ButtonPrimary>
                    </>
                }
                {
                  isErrorSalihaAuth && errorMessage(errorMessageSalihaAuth)
                }
              </div>
            </div>

            {
              isFetchingCreateDataPuNib ? <>
                <section className="p-5">
                  <div className="mb-5 flex items-center justify-start gap-5">
                    <svg
                      className="animate-spin -ml-1 mr-3 h-5 w-5"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="3"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>

                    Mohon tunggu, sedang memuat data pengajuan
                  </div>
                </section>
              </> : (
                <section className="p-5">
                  {!isFetchingSalihaAuth &&
                    dataCredentials.CREDENTIALS_SSO.data.JenisPendaftaran === "CH003" ? (
                    <>
                      <div className="mb-5 flex items-center justify-between">
                        <h4 className="font-medium text-slate-500">Pengajuan Selfdeclare</h4>
                        <div className="rounded-md bg-purple-100 px-2 font-semibold text-gray-900"></div>
                      </div>
                      <div className="space-y-2">
                        {
                          renderPuTableSelfdeclare()
                        }
                      </div>

                    </>
                  ) : (
                    <>
                      <div className="mb-5 flex items-center justify-between">
                        <h4 className="font-medium text-slate-500">Pengajuan Reguler</h4>
                        <div className="rounded-md bg-purple-100 px-2 font-semibold text-gray-900"></div>
                      </div>
                      <div className="space-y-2">
                        {
                          renderPuTableReguler()
                        }
                      </div>

                    </>
                  )
                  }


                </section>
              )
            }


            {/* <section className="p-5">
              <div className="flex flex-row space-x-3 w-full">
                <ButtonSecondary
                  // disabled={!client}
                  // loading={isFetching}
                  className="w-full"
                  type="button"
                  onClick={() => doLogout()}
                >
                  Keluar <XCircleIcon className="font-bold ml-5 w-6" />
                </ButtonSecondary>
                <ButtonPrimary
                  // disabled={!client}
                  loading={isFetchingReg}
                  className="w-full"
                  type="button"
                  onClick={() => doSalihaSubmission()}
                >
                  Selanjutnya <ArrowRightOnRectangleIcon className="font-bold ml-5 w-6" /> <br />
                </ButtonPrimary>
              </div>
            </section> */}

          </div>
        </div>

      </div>

    </div>
  );
};

export default SalihaSubmission;
